export const GET_TABLE_SUCCESS = "GET_TABLE_SUCCESS";
export const GET_TABLE_FAILURE = "GET_TABLE_FAILURE";

export const GET_TABLES_SUCCESS = "GET_TABLES_SUCCESS";
export const GET_TABLES_FAILURE = "GET_TABLES_FAILURE";

export const RESET_ADD_TABLE = "RESET_ADD_TABLE"
export const ADD_TABLE_SUCCESS = "ADD_TABLE_SUCCESS";
export const ADD_TABLE_FAILURE = "ADD_TABLE_FAILURE";

export const RESET_EDIT_TABLE = "RESET_EDIT_TABLE";
export const EDIT_TABLE_SUCCESS = "EDIT_TABLE_SUCCESS";
export const EDIT_TABLE_FAILURE = "EDIT_TABLE_FAILURE";

export const RESET_DELETE_TABLE = "RESET_DELETE_TABLE";
export const DELETE_TABLE_SUCCESS = "DELETE_TABLE_SUCCESS";
export const DELETE_TABLE_FAILURE = "DELETE_TABLE_FAILURE";